enum ReservaDeSangueFiltradoEnum {
  Filtrado = 'Filtrado',
  FiltradoEIrradiado = 'FiltradoEIrradiado',
}

export default ReservaDeSangueFiltradoEnum
